<div class="row dashboardBlock">
  <div class="col-12">
    <div class="row" [ngClass]="isArabic ? 'arabicAlign' : ''">
      <div class="col-sm-2 col-md-3 padding-menu">
        <div class="actionItemsList">
          <ul>
            <ng-container *ngFor="let item of enforcementList; let i = index">
              <li *ngIf="item.isShow"
                [ngClass]="item.isActive ? (isArabic ? 'active arabicAlign' : 'active') : (isArabic ? 'cursor-pointer arabicAlign' : 'cursor-pointer')"
                (click)="onListItemClick(i)">
                <span class="stepNumber">
                  <img [src]="item.img" alt="" />
                </span>
                <span class="stepText" *ngIf="!isArabic">{{ item.value }}</span>
                <span class="stepText" *ngIf="isArabic">{{ item.arabicValue }}</span>
                <div *ngIf="item.link == 'enforcement/active' && enforcementCount" class="item-count"
                  [ngClass]="isArabic ? 'arabicCount' : ''">{{enforcementCount}}</div>
                  <!-- <div *ngIf="item.link == 'action-items/pending' && pendingCount>0" class="item-count"
                    [ngClass]="isArabic ? 'arabicCount' : ''">{{pendingCount}}</div>  -->
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
      <div class="col-sm-10 col-md-9 assessment-right">
        <router-outlet (activate)="subscribeToEmitter($event)"></router-outlet>
      </div>
    </div>
  </div>
</div>